export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": ["Organization", "LocalBusiness"],
  "@id": "https://www.mag-automate.com/#organization",
  name: "Manufacturing Automation Group",
  alternateName: "MAG",
  legalName: "Manufacturing Automation Group, LLC",
  foundingDate: "2024",
  foundingLocation: {
    "@type": "Place",
    name: "Detroit, Michigan",
  },
  brand: {
    "@type": "Brand",
    name: "MAG",
  },
  url: "https://www.mag-automate.com/",
  logo: "https://www.mag-automate.com/mag-logo-hd.png",
  image: [
    "https://www.mag-automate.com/mag-logo-hd.png",
    "https://www.mag-automate.com/images/Image.jpg",
    "https://www.mag-automate.com/mag-team-photo.jpg",
  ],
  email: "solutions@mag-automate.com",
  telephone: "734-352-9828",
  description:
    "Turnkey AMR and AGV integration for automotive and industrial manufacturers: planning, system and fleet-management integration, launch stabilization, and 24/7 production support.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "35572 Veronica St",
    addressLocality: "Livonia",
    addressRegion: "MI",
    postalCode: "48150",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 42.3771743,
    longitude: -83.394502,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "07:30",
      closes: "17:30",
    },
  ],
  areaServed: [
    { "@type": "State", name: "Michigan" },
    { "@type": "Country", name: "United States" },
    { "@type": "Country", name: "Canada" },
    { "@type": "Country", name: "Mexico" },
  ],
  sameAs: ["https://www.linkedin.com/company/mag-automate"],
  knowsAbout: [
    "Autonomous Mobile Robots (AMR)",
    "Automated Guided Vehicles (AGV)",
    "AMR fleet management integration",
    "Industrial automation integration",
    "Intralogistics automation",
    "Brownfield automation planning",
  ],
  makesOffer: [
    {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "AMR Integration",
        url: "https://www.mag-automate.com/products-services",
      },
    },
    {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "AGV Integration",
        url: "https://www.mag-automate.com/products-services",
      },
    },
    {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "Fleet Management Software Integration",
        url: "https://www.mag-automate.com/products-services",
      },
    },
    {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "Automation Planning & Engineering",
        url: "https://www.mag-automate.com/products-services",
      },
    },
    {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "Launch Stabilization & 24/7 Production Support",
        url: "https://www.mag-automate.com/products-services",
      },
    },
  ],
};
